<template>
    <div class="p-5 text-center bg-body-tertiary">
        <div class="container-fluid py-5">
            <h1 class="display-1">Portfolio</h1>
            <p class="col-lg-8 mx-auto lead">
                This page is a showcase of some of the tech I am familiar with.<br />
                Each project has been put together using various types of tech in order to demo their use case.<br />
                Also listed is the tech used within each web app.
            </p>
        </div>
    </div>
</template>